export const educationData = [
    {
        id: 1,
        institution: 'Nehru Institute of Information Technology and Management',
        course: 'Master of Computer Application',
        startYear: '2018',
        endYear: '2020'
    },
    {
        id: 2,
        institution: 'Nehru Arts and Science College',
        course: 'Bachelor of Computer Application',
        startYear: '2015',
        endYear: '2018'
    },
    {
        id: 3,
        institution: "St.Paul's Higher Secondary School",
        course: 'Higher Secondary Education',
        startYear: '2014',
        endYear: '2015'

    },
]